import { createFileRoute } from '@tanstack/react-router';
import { MaterialModal } from 'src/components/creator/MaterialModal';

const CreateMultimediaMaterialRoute = () => (
  <MaterialModal defaultFormat="multimedia" />
);

export const Route = createFileRoute(
  '/_authenticated/_creator/materials/create/multimedia'
)({
  component: CreateMultimediaMaterialRoute,
});
